var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer pa-4"},[_c('v-row',{staticClass:"flex-column fill-height",attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('Spinner',{attrs:{"width":"286","height":"182"}}),_vm._v(" Loading... ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }